import React, { useEffect, useState } from 'react'
import { Card, Grid, Button, Typography } from '@material-ui/core'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import { Link, useLocation } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import axios from 'axios.js'

const useStyles = makeStyles(() => ({
    root: {
        borderRadius: 10,
    },
    card: {
        maxWidth: 800,
        borderRadius: 16,
        margin: '1rem',
        boxShadow: '0px 0px 13px 3px #eeeeee',
    },
}))

const ForgotPassword = () => {
    const classes = useStyles()
    const location = useLocation()
    const [form, setForm] = useState({
        email: '',
        token: '',
        new_password: '',
        confirm_password: '',
    })
    const [msg, setMsg] = useState('')
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const params = new URLSearchParams(location.search || '')
        const tokenFromUrl = params.get('token') || ''
        if (tokenFromUrl) {
            setForm((prev) => ({ ...prev, token: tokenFromUrl }))
            setMsg('Токен из ссылки подставлен. Укажите новый пароль и подтвердите.')
        }
    }, [location.search])

    const handleChange = ({ target: { name, value } }) => {
        setForm((prev) => ({ ...prev, [name]: value }))
    }

    const requestToken = async () => {
        setLoading(true)
        setError('')
        setMsg('')
        try {
            const res = await axios.post('/api/auth/forgot-password/request', { email: form.email })
            const payload = res?.data || {}
            if (payload?.error) {
                setError(payload?.errorInfo || 'Ошибка запроса токена')
                return
            }
            setMsg('Если email существует, ссылка для восстановления отправлена на почту.')
        } catch (e) {
            setError(e?.response?.data?.message || e?.message || 'Ошибка запроса токена')
        } finally {
            setLoading(false)
        }
    }

    const resetPassword = async () => {
        setLoading(true)
        setError('')
        setMsg('')
        try {
            if ((form.new_password || '').length < 6) {
                setError('Пароль должен содержать минимум 6 символов')
                return
            }
            if (form.new_password !== form.confirm_password) {
                setError('Пароли не совпадают')
                return
            }
            const res = await axios.post('/api/auth/forgot-password/reset', {
                token: form.token,
                new_password: form.new_password,
            })
            const payload = res?.data || {}
            if (payload?.error) {
                setError(payload?.errorInfo || 'Ошибка сброса пароля')
                return
            }
            setMsg('Пароль успешно изменён. Теперь можно войти с новым паролем.')
            setForm((prev) => ({ ...prev, new_password: '', confirm_password: '' }))
        } catch (e) {
            setError(e?.response?.data?.message || e?.message || 'Ошибка сброса пароля')
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className={clsx('flex justify-center items-center  min-h-full-screen')}>
            <Card className={classes.card}>
                <div style={{ textAlign: 'center', fontSize: 50, fontFamily: 'Cocomat', marginTop: '10%' }}>
                    pixel<span style={{ color: '#9400d3' }}>crm</span>
                </div>
                <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <div className="p-8 h-full relative">
                            <ValidatorForm onSubmit={(e) => e.preventDefault()}>
                                <TextValidator
                                    className="mb-4 w-full"
                                    variant="outlined"
                                    label="Почта"
                                    InputProps={{ classes: { root: classes.root } }}
                                    onChange={handleChange}
                                    type="email"
                                    name="email"
                                    size="small"
                                    value={form.email || ''}
                                    validators={['required', 'isEmail']}
                                    errorMessages={['Поле обязательно для заполнения', 'Введите корректный email']}
                                />
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={requestToken}
                                    disabled={loading}
                                    className="mb-4"
                                >
                                    {loading ? 'Запрос...' : 'Отправить ссылку для восстановления'}
                                </Button>

                                <TextValidator
                                    className="mb-4 w-full"
                                    variant="outlined"
                                    label="Токен"
                                    InputProps={{ classes: { root: classes.root } }}
                                    onChange={handleChange}
                                    type="text"
                                    name="token"
                                    size="small"
                                    value={form.token || ''}
                                    validators={['required']}
                                    errorMessages={['Поле обязательно для заполнения']}
                                />
                                <TextValidator
                                    className="mb-4 w-full"
                                    variant="outlined"
                                    label="Новый пароль"
                                    InputProps={{ classes: { root: classes.root } }}
                                    onChange={handleChange}
                                    type="password"
                                    name="new_password"
                                    size="small"
                                    value={form.new_password || ''}
                                    validators={['required']}
                                    errorMessages={['Поле обязательно для заполнения']}
                                />
                                <TextValidator
                                    className="mb-4 w-full"
                                    variant="outlined"
                                    label="Повторите пароль"
                                    InputProps={{ classes: { root: classes.root } }}
                                    onChange={handleChange}
                                    type="password"
                                    name="confirm_password"
                                    size="small"
                                    value={form.confirm_password || ''}
                                    validators={['required']}
                                    errorMessages={['Поле обязательно для заполнения']}
                                />

                                {!!error && (
                                    <Typography style={{ color: '#b91c1c', marginBottom: 8 }}>
                                        {error}
                                    </Typography>
                                )}
                                {!!msg && (
                                    <Typography style={{ color: '#15803d', marginBottom: 8 }}>
                                        {msg}
                                    </Typography>
                                )}

                                <div className="flex items-center">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={resetPassword}
                                        disabled={loading}
                                    >
                                        {loading ? 'Сохранение...' : 'Сбросить пароль'}
                                    </Button>
                                    <span className="ml-4 mr-2">или</span>
                                    <Link to="/session/signin">
                                        <Button className="capitalize">Вход</Button>
                                    </Link>
                                </div>
                            </ValidatorForm>
                        </div>
                    </Grid>
                </Grid>
            </Card>
        </div>
    )
}

export default ForgotPassword
